// extracted by mini-css-extract-plugin
export default {"font-renta":"FormResource_font-renta__DdXuJ","formResource":"FormResource_formResource__uZEWG","title":"FormResource_title__pJZ-L"};